import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';

// import styles bundle
import 'swiper/css/bundle';


const thumbKudan = document.querySelectorAll('.p-facility__slider__thumb.--kudan .p-facility__slider__thumb__media');
const thumbOgikubo = document.querySelectorAll('.p-facility__slider__thumb.--ogikubo .p-facility__slider__thumb__media');

const switchThumbKudan = (index) => {
  document.querySelector('.p-facility__slider__thumb.--kudan .thumb-active').classList.remove('thumb-active');
  thumbKudan[index].classList.add('thumb-active');
}
const switchThumbOgikubo = (index) => {
  document.querySelector('.p-facility__slider__thumb.--ogikubo .thumb-active').classList.remove('thumb-active');
  thumbOgikubo[index].classList.add('thumb-active');
}

const optionKudan = {
  modules: [Navigation, EffectFade],
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  speed: 500,
  on: {
    afterInit: (swiper) => {
      thumbKudan[swiper.realIndex].classList.add('thumb-active');
      for (let i = 0; i < thumbKudan.length; i++) {
        thumbKudan[i].onclick = () => {
          swiper.slideTo(i);
        };
      }
    },
    slideChange: (swiper) => {
      switchThumbKudan(swiper.realIndex);
    },
  }
}

const optionOgikubo = {
  modules: [Navigation, EffectFade],
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  speed: 500,
  on: {
    afterInit: (swiper) => {
      thumbOgikubo[swiper.realIndex].classList.add('thumb-active');
      for (let i = 0; i < thumbOgikubo.length; i++) {
        thumbOgikubo[i].onclick = () => {
          swiper.slideTo(i);
        };
      }
    },
    slideChange: (swiper) => {
      switchThumbOgikubo(swiper.realIndex);
    },
  }
}


const optionTeam = {
  modules: [Navigation, Pagination],
  speed: 1200,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
  },
  spaceBetween: 16,
  slidesPerView: 1,
  breakpoints: {
    768: {
      slidesPerView: 2.5,
    },
    992: {
      spaceBetween: 32,
      slidesPerView: 2.25,
    }
  }
}

export default function slider() {
  const swiperTeam = new Swiper('.p-team__contents', optionTeam);
  const swiperKudan = new Swiper('.p-facility__slider.--kudan', optionKudan);
  const swiperOgikubo = new Swiper('.p-facility__slider.--ogikubo', optionOgikubo);
}